import { ChangeDetectionStrategy, Component, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ILightWeightUser, ILightWeightUserWithUnits } from '@fi-shared/models';

@Component({
    selector: 'fi-chat-conversation-users-list',
    template: `
        @for (user of users; track user; let userIndex = $index) {
          <fi-chat-conversation-users-list-item
            (onUserCardClick)="userCardClick($event)"
            [user]="user"
            [disabled]="isUserDisabled(user)"
            [selectedUsers]="selectedUsers"
            [isRippleEffect]="isRippleEffect"
            [isTooltipAvailable]="isTooltipAvailable"
            [tooltipText]="tooltipText"
            />
        }
        `,
    styleUrls: ['./fi-chat-conversation-users-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-users-list' },
    standalone: false,
})
export class FiChatConversationUsersListComponent {
    @Input() users: ILightWeightUserWithUnits[] | ILightWeightUser[] = [];
    @Input() disabledUserIds: number[] = [];
    @Input() selectedUsers: ILightWeightUserWithUnits[] | ILightWeightUser[] = [];
    @Input() isRippleEffect: boolean;
    @Input() isTooltipAvailable = false;
    @Input() tooltipText: string | ((userId: number) => string);
    @Output() onUserCardClick = new EventEmitter<ILightWeightUserWithUnits | ILightWeightUser>();

    userCardClick(user: ILightWeightUserWithUnits | ILightWeightUser) {
        this.onUserCardClick.emit(user);
    }

    isUserDisabled(user: ILightWeightUserWithUnits | ILightWeightUser) {
        return this.disabledUserIds.indexOf(user.Id) !== -1;
    }
}
